<div [class]="containerClasses()">
  @if (showSkeleton()) {
    <div class="absolute inset-0 z-10">
      <app-dynamic
        componentName="Skeleton"
        [props]="{ config: skeletonConfig() }"
      />
    </div>
  }

  <img
    [ngSrc]="config().src"
    [alt]="config().alt ?? ''"
    [width]="dimensions().width"
    [height]="dimensions().height"
    [priority]="config().priority ?? false"
    [class]="imageClasses()"
    (load)="onImageLoad()"
  />
</div>
